const situations = [
  'Компания быстро растёт, и нагрузка на существующих сотрудников увеличивается',
  'Появляются новые подразделения, которым нужны подготовленные люди',
  'Необходимо масштабировать бизнес, а компетенции сотрудников не успевают',
  'Меняются процессы, и сотрудникам нужно осваивать новые подходы',
  'Внедряется CRM/ERP или другие технологии, требующие новых навыков',
  'Необходимо повысить самостоятельность сотрудников',
  'Формируется кадровый резерв для будущих руководителей',
  'Компания хочет снизить зависимость от отдельных специалистов',
  'Появляются новые руководители, которым нужно освоить управленческую роль',
  'Необходимо изменить корпоративную культуру',
  'Обучение уже проводилось, но поведение сотрудников практически не изменилось',
  'Собственник хочет создать более самостоятельную управленческую систему',
];

export default function WhenNeeded() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Когда компании особенно необходимо системное развитие персонала
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Есть ситуации, в которых развитие сотрудников перестаёт быть «хорошей идеей» и становится бизнес-задачей.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {situations.map((s, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl border border-gray-100 hover:border-teal-200 transition-colors">
              <div className="w-8 h-8 bg-teal-600 text-white rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-sm font-bold">{i + 1}</span>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{s}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}